import { render, staticRenderFns } from "./SselectCriteriaCollection.vue?vue&type=template&id=7496cef7"
import script from "./SselectCriteriaCollection.vue?vue&type=script&lang=js"
export * from "./SselectCriteriaCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports